module.exports = "/_next/static/images/row1-4-2x-2ff1dc2e3648e4e164203e509472674f.png";